import _ from 'lodash';

export const fromRedToGreen = (value: number, lightenValue?: number) => {
    let color0 = [71, 57, 231];
    let color1 = [118, 0, 214];
    let color2 = [255, 186, 0];

    if (lightenValue) {
        color0 = [color0[0] + (255 - color0[0]) * lightenValue, color0[1] + (255 - color0[1]) * lightenValue, color0[2] + (255 - color0[2]) * lightenValue];
        color1 = [color1[0] + (255 - color1[0]) * lightenValue, color1[1] + (255 - color1[1]) * lightenValue, color1[2] + (255 - color1[2]) * lightenValue];
        color2 = [color2[0] + (255 - color2[0]) * lightenValue, color2[1] + (255 - color2[1]) * lightenValue, color2[2] + (255 - color2[2]) * lightenValue];
    }
    if (value < 0.5) {
        const percent = value / 0.5;
        const red = color0[0] + Math.round((color1[0] - color0[0]) * percent);
        const green = color0[1] + Math.round((color1[1] - color0[1]) * percent);
        const blue = color0[2] + Math.round((color1[2] - color0[2]) * percent);
        return `rgb(${red},${green},${blue})`;
    }
    const percent = (value - 0.5) / 0.5;
    const red = color1[0] + Math.round((color2[0] - color1[0]) * percent);
    const green = color1[1] + Math.round((color2[1] - color1[1]) * percent);
    const blue = color1[2] + Math.round((color2[2] - color1[2]) * percent);
    return `rgb(${red},${green},${blue})`;
};

export const createHistogramDataForAttribute = (scores: number[]) => {
    const maxScore = _.max(scores);
    let step = 1;
    if (maxScore! > 15) {
        step = Math.round(maxScore! / 5);
    }
    const data: any[] = [];
    const steps = Math.max(1, Math.floor(maxScore! / step));
    for (let i = 0; i <= maxScore!; i += step) {
        data.push({ name: i, count: 0, color: fromRedToGreen((i / step) / steps) });
    }
    scores.forEach((score) => {
        data.forEach((bin) => {
            if (score >= bin.name && score < bin.name + step) {
                bin.count += 1;
            }
        });
    });
    return data;
};
